import React from "react";

const Reviews = () => {
  return (
    <div
      className="elfsight-app-dcb2392a-adda-4133-961f-a71961434889"
      data-elfsight-app-lazy
    ></div>
  );
};

export default Reviews;
